import React, { useEffect } from 'react';
import { HeroSection } from '../components/HeroSection';
import { PainSection } from '../components/PainSection';
import { EnemySection } from '../components/EnemySection';
import { SolutionSection } from '../components/SolutionSection';
import { WhatInsideSection } from '../components/WhatInsideSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { OfferSection } from '../components/OfferSection';
import { BonusSection } from '../components/BonusSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { CloseSection } from '../components/CloseSection';
import { initMetaPixel, trackPageView } from '../utils/metaPixel';
export function SalesPage() {
  useEffect(() => {
    initMetaPixel();
    trackPageView();
  }, []);
  return <main className="min-h-screen bg-navy text-white selection:bg-gold selection:text-navy" data-id="element-189">
      <HeroSection data-id="element-190" />
      <PainSection data-id="element-191" />
      <EnemySection data-id="element-192" />
      <SolutionSection data-id="element-193" />
      <WhatInsideSection data-id="element-194" />
      <TestimonialsSection data-id="element-195" />
      <OfferSection data-id="element-196" />
      <BonusSection data-id="element-197" />
      <GuaranteeSection data-id="element-198" />
      <CloseSection data-id="element-199" />
    </main>;
}